module.exports = __webpack_public_path__ + "img/hc3620_center_002.6deaee47.png";